import Logo from "../../Logo";
import NavLink from "../NavLink";
import ExitButton from "../../ExitButton";
import { FunctionComponent } from "react";

import styles from "./styles.module.css";

interface NavProps {
  activeIndex: number;
}

const Navbar: FunctionComponent<NavProps> = ({ activeIndex }) => {
  const bolArray = [false, false, false, false];
  bolArray[activeIndex] = true;

  return (
    <nav className={styles.navBar}>
      <Logo />
      <ul>
        <NavLink
          name="Instituições"
          link="/instituicoes"
          icon="group"
          active={bolArray[0]}
        />
        <NavLink
          name="Cooperação Técnica"
          link="/solicitacoes"
          icon="hands"
          active={bolArray[1]}
          state={{ modalidade: "contribuicao", indexNavbar: 1, icon: "hands", title: "Cooperação Técnica" }}
        />
        <NavLink
          name="Colaboração"
          link="/colaboracoes"
          icon="document"
          active={bolArray[2]}
        />
        <NavLink
          name="Fomentos"
          link="/fomentos"
          icon="bank"
          active={bolArray[3]}
          state={{ modalidade: "fomento", indexNavbar: 3, icon: "bank", title: "Fomento" }}
        />
      </ul>
      <ExitButton />
    </nav>
  );
};

export default Navbar;
